import { render, staticRenderFns } from "./strategy-cluster.vue?vue&type=template&id=0a0ab960&scoped=true"
import script from "./strategy-cluster.vue?vue&type=script&lang=ts"
export * from "./strategy-cluster.vue?vue&type=script&lang=ts"
import style0 from "./strategy-cluster.vue?vue&type=style&index=0&id=0a0ab960&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ab960",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a0ab960')) {
      api.createRecord('0a0ab960', component.options)
    } else {
      api.reload('0a0ab960', component.options)
    }
    module.hot.accept("./strategy-cluster.vue?vue&type=template&id=0a0ab960&scoped=true", function () {
      api.rerender('0a0ab960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/performance-assessment/strategy-cluster.vue"
export default component.exports